
import { BlueButton } from '@share/components';

import Luggage from '@assets/images/ashevilleplay/luggage.svg';
import Camera from '@assets/images/ashevilleplay/camera.svg';

import Card1 from '@assets/images/ashevilleplay/card-1.jpg';
import Card2 from '@assets/images/ashevilleplay/card-2.jpg';

import './style.scss';

type OnClickAction = (action: string) => void;

export const ACTION_IDS = {
  BOOK_NOW: 'book-now',
  UPGRADE_YOUR_TRIP: 'upgrade-your-trip',
};

interface IAction {
  background: string;
  image: string;
  title: string;
  description: string;
  message: string;
  action: string;
  actionId: string;
}

interface IPropsItem {
  action: IAction;
  onClick: OnClickAction;
}

interface IProps {
  onClick: OnClickAction;
}

const ACTIONS: IAction[] = [
  {
    background: Card1,
    image: Luggage,
    title: 'Best Hotel Deals',
    description: 'Save up to 15%',
    message: 'These deals are better than Expedia.com',
    action: 'Book Now',
    actionId: ACTION_IDS.BOOK_NOW,
  },
  {
    background: Card2,
    image: Camera,
    title: 'Must-See Attractions',
    description: 'Tours, Views & Stories',
    message: 'Loved by locals ond visitors alike!',
    action: 'Upgrade Your Trip',
    actionId: ACTION_IDS.UPGRADE_YOUR_TRIP,
  },
];

function SearchAshevillePlayHeaderBottomItem({ onClick, action }: IPropsItem) {

  return (
    <div className="search-asheville-play-header-bottom-item" style={{ backgroundImage: `url(${action.background})` }}>
      <div className="overlay-brand"></div>
      <div className="search-asheville-play-header-bottom-item-content">
        <img src={action.image} alt={action.title} />
        <h3>{action.title}</h3>
        <label>{action.description}</label>
        <p>{action.message}</p>
      </div>
      <BlueButton onClick={() => onClick(action.actionId)}>{action.action}</BlueButton>
    </div>
  );
}

export function SearchAshevillePlayHeaderBottom({ onClick }: IProps) {
  return (
    <div className="search-asheville-play-header-bottom">
      {ACTIONS.map((action, index) => (
        <SearchAshevillePlayHeaderBottomItem key={index} onClick={onClick} action={action} />))}
    </div>
  );
}
